import React, { Component } from 'react';
import Page from '../pages/Page';
import AppContainer from '../containers/App';
import { title, meta, link } from './assets';
import Navigation from 'containers/Navigation';
import Footer from 'containers/Footer';
import { addLocaleData, IntlProvider } from 'react-intl';
import en from 'react-intl/locale-data/en';
import de from 'react-intl/locale-data/de';
import fr from 'react-intl/locale-data/fr';
import es from 'react-intl/locale-data/es';
import pt from 'react-intl/locale-data/pt';
import it from 'react-intl/locale-data/it';
import nl from 'react-intl/locale-data/nl';
import ro from 'react-intl/locale-data/ro';
import pl from 'react-intl/locale-data/pl';
import cs from 'react-intl/locale-data/cs';
import sk from 'react-intl/locale-data/sk';
import hu from 'react-intl/locale-data/hu';
import el from 'react-intl/locale-data/el';
import bg from 'react-intl/locale-data/bg';
import hr from 'react-intl/locale-data/hr';
import sr from 'react-intl/locale-data/sr';
import sl from 'react-intl/locale-data/sl';
import da from 'react-intl/locale-data/da';
import sv from 'react-intl/locale-data/sv';
import no from 'react-intl/locale-data/no';
import fi from 'react-intl/locale-data/fi';
import lt from 'react-intl/locale-data/lt';
import lv from 'react-intl/locale-data/lv';
import et from 'react-intl/locale-data/et';
import tr from 'react-intl/locale-data/tr';
import uk from 'react-intl/locale-data/uk';
import zh from 'react-intl/locale-data/zh';
import ja from 'react-intl/locale-data/ja';
import ar from 'react-intl/locale-data/ar';
import catalog from '../intl/catalog';
import { connect } from 'react-redux'
import { flattenMessages, getLanguageMessages, getLocale } from '../intl/helpers';
import Joyride from 'react-joyride';

addLocaleData([...en, ...de, ...fr, ...es, ...pt, ...it, ...nl, ...ro, ...pl, ...cs, ...sk, ...hu, ...el, ...bg, ...hr, ...sr, ...sl, ...da, ...sv, ...no, ...fi, ...lt, ...lv, ...et, ...tr, ...uk, ...zh, ...ja, ...ar]);

class App extends Component {
  state = {
    run: false,
    index: 0,
    showSkipButton: true,
    steps: []
  }

  buildSteps(messages) {
    return [
      {
        target: '#orders-menu',
        title: messages['joyride.welcomeTitle'],
        content: <p>{messages['joyride.welcomeContent']}</p>,
        placement: 'center',
        event: 'click'
      },
      {
        target: '#all-orders',
        title: messages['joyride.dashboardTitle'],
        content: <p>{messages['joyride.dashboardContent']}</p>,
        placement: 'center',
        event: 'click'
      },
      {
        target: '#autopilot-menu',
        title: messages['joyride.automationTitle'],
        content: <p>{messages['joyride.automationContent']}</p>,
        placement: 'auto',
        event: 'click'
      },
      {
        target: '#templates-menu',
        title: messages['joyride.templatesTitle'],
        content: <p>{messages['joyride.templatesContent']}</p>,
        placement: 'auto',
        event: 'auto'
      },
      {
        target: '#delivery-menu',
        title: messages['joyride.deliveryTitle'],
        content: <p>{messages['joyride.deliveryContent']}</p>,
        placement: 'auto',
        event: 'auto'
      },
      {
        target: '#settings-menu',
        title: messages['joyride.settingsTitle'],
        content: <div>
                    <ol>
                      <li>{messages['joyride.settingsContent1']}</li>
                      <li>{messages['joyride.settingsContent2']}</li>
                      <li>{messages['joyride.settingsContent3']}</li>
                      <li>{messages['joyride.settingsContent4']}</li>
                    </ol>
                </div>,
        placement: 'auto',
        event: 'auto'
      },
      {
        target: '#review-menu',
        title: messages['joyride.reviewTitle'],
        content: <p>{messages['joyride.reviewContent']}</p>,
        placement: 'auto',
        event: 'auto'
      },
      {
        target: '#welcome-tour-menu',
        title: messages['joyride.tourTitle'],
        content: <p>{messages['joyride.tourContent']}</p>,
        placement: 'auto',
        event: 'auto'
      },
      {
        target: '.btn-create',
        title: messages['joyride.createDocTitle'],
        content: <p>{messages['joyride.createDocContent']}</p>,
        placement: 'auto',
        event: 'auto'
      },
      {
        target: '.btn-order-edit',
        title: messages['joyride.docNumberTitle'],
        content: <p>{messages['joyride.docNumberContent']}</p>,
        placement: 'auto',
        event: 'auto'
      },
      {
        target: '#download-dd',
        title: messages['joyride.downloadDocTitle'],
        content: <p>{messages['joyride.downloadDocContent']}</p>,
        placement: 'auto',
        event: 'auto'
      }
    ];
  }

  componentDidMount() {
    this.setState({ run: true });
    const { user } = this.props;

    let runJoyride = false;
    let joyrideIndex = 0;

    if (typeof localStorage !== 'undefined') {
      runJoyride = localStorage.getItem(user.shopify.shopName + 'run-joyride') !== "false";
      joyrideIndex = Number(localStorage.getItem(user.shopify.shopName + 'joyride-index'));
      this.setState({
        run: runJoyride,
        index: joyrideIndex
      });
    }

  }

  callback = (data) => {
    const { action, index, lifecycle } = data;
    const { user } = this.props;

    if (typeof localStorage !== 'undefined') {
      if (lifecycle !== "init" && action === "prev") {
        localStorage.setItem(user.shopify.shopName + 'joyride-index', index - 1);

        this.setState({
          index: index - 1
        })
      }

      if (lifecycle !== "init" && action === "next") {
        localStorage.setItem(user.shopify.shopName + 'joyride-index', index + 1);

        this.setState({
          index: index + 1
        })
      }

      if (index === this.state.steps.length - 1) {
        localStorage.setItem(user.shopify.shopName + 'run-joyride', false);
      }


    };
  }


  render() {
    let { detectedLanguage } = this.props;

    if (this.props.params && this.props.params.locale) {
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('invoicebrowse_locale', this.props.params.locale)
      }
      detectedLanguage = this.props.params.locale;
    }

    let locale = getLocale(detectedLanguage);
    let langMessages = getLanguageMessages(catalog, detectedLanguage);
    let messages = flattenMessages(langMessages);
    let steps = this.buildSteps(messages);

    return (
      <IntlProvider locale={locale} messages={messages}>

        <div className="layout">

          <div className="layout-body">
            <div className="layout-content-wrapper">
              <main className="layout-content">
                <Page title={title} meta={meta} link={link}>
                  <Joyride

                    showProgress={true}
                    continuous={true}
                    run={this.state.run && !/administrator/.test(window.location.pathname)}
                    steps={steps}
                    floaterProps={{
                      styles: {
                        wrapper: {
                          zIndex: 9999999
                        },
                      },
                    }}
                    styles={{
                      options: {
                        zIndex: 9999999,
                      }
                    }}
                    stepIndex={this.state.index}
                    callback={this.callback.bind(this)}
                  >
                    <div></div>
                  </Joyride>
                  <AppContainer {...this.props} />
                </Page>
              </main>
              <footer className="layout-footer">
                <Footer />
              </footer>
            </div>
            <nav className="layout-nav">
              <Navigation />
            </nav>
          </div>
        </div>


      </IntlProvider>
    );
  }
}

function mapStateToProps(state) {
  return {
    detectedLanguage: state.user.detectedLanguage,
    user: state.user
  }
}

export default connect(mapStateToProps)(App)



// WEBPACK FOOTER //
// app/pages/App.jsx